(function faqBlocks() {
    if (!Element.prototype.matches) {
        Element.prototype.matches =
            Element.prototype.matchesSelector ||
            Element.prototype.mozMatchesSelector ||
            Element.prototype.msMatchesSelector ||
            Element.prototype.oMatchesSelector ||
            Element.prototype.webkitMatchesSelector ||
            function (s) {
                var matches = (this.document || this.ownerDocument).querySelectorAll(s),
                    i = matches.length;
                while (--i >= 0 && matches.item(i) !== this) {
                }
                return i > -1;
            };
    }

    function findAncestor(el, sel) {
        if (typeof el.closest === "function") {
            return el.closest(sel) || null;
        }
        while (el) {
            if (el.matches(sel)) {
                return el;
            }
            el = el.parentElement;
        }
        return null;
    }

    var faqBlocks = document.querySelectorAll("[data-expandable-faq=\"true\"]");

    if (faqBlocks.length > 0) {
        for (var i = 0; i < faqBlocks.length; i++) {
            var header = faqBlocks[i].querySelector("[data-trigger=\"true\"]");
            if (header) {
                header.addEventListener("click", expandCollapse, false);
                header.addEventListener("keypress", function (e) {
                    var key = e.which || e.keyCode;
                    if (key === 13) {
                        expandCollapse.call(e.currentTarget);
                    }
                }, false);
            }
        }
    }

    function expandCollapse() {
        var thisSection = this.parentNode;
        var isOpen = thisSection.classList.contains("open");
        var parentCategory = findAncestor(thisSection.parentNode, ".faq-category");

        for (var i = 0; i < faqBlocks.length; i++) {
            if (!parentCategory || parentCategory !== faqBlocks[i]) {
                faqBlocks[i].classList.remove("open");
                faqBlocks[i].setAttribute("aria-expanded", "false");
            }
        }

        if (!isOpen) {
            thisSection.classList.add("open");
            thisSection.setAttribute("aria-expanded", "true");
        }
    }
})();